<template>
    <Modal v-model:open="open"><template #container>
      <div class="Feedback">
        <Form class="Modal__container" :initial="initial()" :validate="validate"
              @submit="handleSubmit">
          <template #default="{ state: { values: { type } }, handleInput }">
            <div class="Modal__header"><h3>Feedback</h3></div>

            <div class="Modal__body">
              <p style="margin-bottom: var(--form-field-gap);">
                Write a message and attach a screenshot.<br>
                <span v-if="type === TYPES.ERROR && isAnyErrors">Error found and will be included on the report to automaticaly.</span>
              </p>
              <!-- <Field name="type">
                <Choose label="Type of message" placeholder="Choose your" :opts="typeOpts" />
              </Field> -->
              <Field name="type" class="Feedback__type">
                <BtnGroup :opts="typeOpts" activeClass="active" />
              </Field>
              <template v-if="!isAuth">
                <Field name="email">
                  <Input type="email" label="Email" placeholder="name@mailbox"
                         required focused />
                </Field>
                <Field name="name">
                  <Input type="text" label="Your name" placeholder="John" />
                </Field>
              </template>
              <Field name="desc">
                <Input type="textarea" label="Description" rows="4" />
              </Field>

              <Field v-if="isAuth" name="attachments">
                <FileUpload multiple
                  @statechange="uploaderIsBusy = ~notAllowedStatesOfUploader.indexOf($event)"
                />
              </Field>

              <FormSubmit :class="type === TYPES.WISH && '--wish'">
                {{ type === TYPES.WISH ? 'Submit' : 'Report' }}
              </FormSubmit>
            </div>
          </template>
        </Form>
      </div>
    </template></Modal>
    <Button class="Feedback__open" :class="isAnyErrors ? 'btn--act' : 'btn--primary'"
            @click="open = true" name="open-feedback">
      <span v-if="isAnyErrors">!</span>
      <Icon v-else name="msg" />
    </Button>
</template>
<script>
import FormSubmit from 'components/FormSubmit';
import Modal from 'components/Modal';
import FileUpload, { STATES as UPLOADER_STATES } from 'components/FileUpload';
import Form, { Field } from '@ohmsd/v-form';
import { notifyError, Enum } from 'utils';

import { addFeedback } from 'api/feedback';
import { uploadFile } from 'api/files';

import bokalSourage from 'services/bokalSourage';
import Identity from 'store/identity.entity';
import store from 'store/store';

const TYPES = new Enum('ERROR', 'WISH');

export default {
  data: () => ({ open: false, files: [], uploaderIsBusy: false, isAnyErrors: false }),

  static () {
    return {
      validate: {
        desc: v => v.length > 8 ? undefined : 'Describe in details',
      },
      initial: () => ({
        desc: '',
        type: this.isAnyErrors ? TYPES.ERROR : TYPES.WISH,
        attachments: [],
        ...(this.isAuth ? { email: Identity.data?.email }
          : { email: bokalSourage.get('Login.email'), name: '' }
        ),
      }),
      typeOpts: {
        [TYPES.ERROR]: 'Error report',
        [TYPES.WISH]: 'Wishes to improve',
      },
      TYPES,
      notAllowedStatesOfUploader: [UPLOADER_STATES.PROGRESS, UPLOADER_STATES.ERROR],
    };
  },

  methods: {
    handleSubmit ({ values, setSubmitting }) {
      const data = {
        ...values,
        attachments: values.attachments.map(_ => _.id),
        data: JSON.stringify(window.$stats, null, '\t'),
      };

      setSubmitting(
        this.uploadState().then(stateFileId => {
          if (stateFileId)
            data.state = stateFileId;

          return addFeedback({ data })
            .then(() => {
              this.open = false;
              this.isAnyErrors = false;
            });
        }).catch(notifyError.bind(this)),
      );
    },

    uploadState () {
      if (!this.isAuth)
        return Promise.resolve(null);

      const state = Object.keys(store).reduce((s, key) => {
        s[key] = store[key].state.data;
        return s;
      }, {});
      const userId = state.Identity?.id || 'unknown';
      const type = 'application/json';
      const blob = new Blob([JSON.stringify(state, null, '\t')], { type });
      const file = new File([blob], `${ userId }.${ Date.now() }.state.json`, { type });
      return uploadFile({ file })
        .then(res => res.data.id);
    },
  },

  computed: {
    isAuth: () => Identity.isAuth,
  },

  created () {
    window.$Feedback = this;
    if (window.$stats && window.$stats.errors.length)
      this.isAnyErrors = true;
  },

  components: { Modal, Form, Field, FileUpload, FormSubmit },
};

</script>
<style>
.Feedback {
  --w: 420px;

  /*.btn {
    z-index: var(--zi-feedback) !important;
  }*/

  .Modal__body {
    display: flex;
    flex-direction: column;
    gap: 16px 0;
  }

  .Modal__container {
    max-width: var(--w);

    p {
      margin-bottom: var(--main-pad);
      font-size: 13px;
    }
  }

  &__type .btn--active {
    color: white;
    border-color: transparent;

    &[value="ERROR"] {
      background-color: var(--brand);

      &:hover, &:focus {
        box-shadow: 0 0 0 3px var(--brand-50);
      }
    }

    &[value="WISH"] {
      background-color: var(--link-hover);

      &:hover, &:focus {
        box-shadow: 0 0 0 3px var(--link-hover-50);
      }
    }
  }

  button[type="submit"] {
    width: 100%;
    height: 44px;

    &.--wish {
      background-color: var(--link-hover);
      border-color: transparent;
      &:hover {
        box-shadow: 0 0 0 3px var(--link-hover-50);
      }
    }
  }

  .FileUpload {
    width: calc(var(--w) - var(--page-pad) * 2);
  }

  &__open.btn {
    position: fixed;
    bottom: 14px;
    right: 14px;

    width: 32px;
    min-width: initial;
    height: 32px;
    padding: 0;
    border-radius: 100%;
    font-size: 24px;
    font-weight: 600;
    z-index: var(--zi-feedback);

    box-shadow: 0 3px 5px 0 var(--black-50);

    &.btn--act {
      animation: 2s puls-scale infinite cubic-bezier(0.89, 0.26, 0.49, 0.87);
    }
  }
}

@keyframes puls-scale {
  0% { transform: scale(1) translateY(0); }
  20% { transform: scale(1.2) translateY(-5px); }
  30% { transform: scale(1.05) translateY(-1px); }
  100% { transform: scale(1)  translateY(0); }
}
</style>
